import { createApp } from 'vue'
import App from './App.vue'
import './main.scss'

createApp(App).mount('#app')
